module.exports = __webpack_public_path__ + "pic/24.111925bb.png";